// tiptap editor用のカラーパレット
export const defaultColors = [
  '#000000',
  '#4A4A4A',
  '#808080',
  '#C0C0C0',
  '#FFFFFF',
  '#800000',
  '#FF0000',
  '#FF7F50',
  '#FFA500',
  '#FFFF00',
  '#9ACD32',
  '#00FF00',
  '#00FFFF',
  '#0000FF',
  '#800080',
];

// brandColorのように一括で更新したい基本色
export const grayColor = {
  10: '#FBFBFB',
  50: '#F7F7F7',
  100: '#F0F0F0',
  150: '#ECECEC',
  200: '#E4E4E4',
  250: '#DDDDDD',
  280: '#D9D9D9',
  350: '#CBCBCB',
  400: '#BBBBBB',
  450: '#888888',
};

export const blackColor = '#292929';
export const whiteColor = '#FFFFFF';
